
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import CardRh from "@/components/cards/ManzaCard.vue";
import AlocacaoService from "@/service/v1/sigap/AlocacaoService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import { Prop } from "vue-property-decorator";

const authStore = namespace("auth");

@Options({
    name: "OpcaoIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class OpcaoIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public modelo: any = null;
    public dados: any = null;
    public opcao_id: any = null;
    public matriculaId: any = null;
    public opcoes: any = null;
    public pelotao = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.opcao_id = null;
        this.pelotao = "";
        this.refreshTable();
    }

    get opcoes_select() {
        if (this.opcoes) {
            return this.opcoes.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getOpcao() {
        this.processando = true;
        this.service.getOpcao()
            .then(response => {
                this.opcoes = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new AlocacaoService();
        this.getOpcao();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    opcao: this.opcao_id,
                    pelotao: this.pelotao,
                    matriculaId: this.matriculaId,
                    search: d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[2, 'asc']];
        this.config.columns = [
            { data: "id", name: "id" },
            { data: "unidade.descricao", name: "unidade" },
            { data: "opcao", name: "opcao", class: "desktop" },
        ];

        this.config.columnDefs = [
            {
                targets: 2,
                render: (row) => {
                    return row.nome.replaceAll("_", " ");
                }
            },
        ];
    }
}
